export interface GlossaryTerm {
  id: number;
  term: string;
  definition: string;
}

export const glossaryRows: GlossaryTerm[] = [
  {
    id: 1,
    term: "ACMR",
    definition: "Assurance Continuity Maintenance Report",
  },
  {
    id: 2,
    term: "Assurance Continuity Maintenance Report (ACMR)",
    definition:
      "Documents the findings of the NIAP Assurance Maintenance review of an IAR.",
  },
  {
    id: 3,
    term: "Assurance Maintenance",
    definition:
      "The process by which vendors maintain their NIAP certification in the face of updates to the evaluated product.",
  },
  {
    id: 4,
    term: "CC",
    definition: "See Common Criteria",
  },
  {
    id: 5,
    term: "CC Certificate",
    definition:
      "A brief public document issued by the NIAP Validation Body under the authority of NIST and NSA which confirms that an IT product or protection profile has successfully completed evaluation by a CCTL. A Common Criteria certificate always has associated with it, a validation report.",
  },
  {
    id: 6,
    term: "CCEVS",
    definition: "Common Criteria Evaluation and Validation Scheme",
  },
  {
    id: 7,
    term: "CCRA",
    definition: "Common Criteria Recognition Arrangement",
  },
  {
    id: 8,
    term: "CCTL",
    definition: "Common Criteria Testing Laboratory",
  },
  {
    id: 9,
    term: "CEM",
    definition: "Common Evaluation Methodology",
  },
  {
    id: 10,
    term: "Check-in Meeting",
    definition:
      "The meeting or point at which all Check-in material is available and approved and the evaluation officially kicks off.",
  },
  {
    id: 11,
    term: "Check-in Package",
    definition:
      "The set of material delivered by a Lab and reviewed by NIAP prior to the official start of the Evaluation.",
  },
  {
    id: 12,
    term: "Check-out Package",
    definition:
      "The set of material delivered by a Lab and reviewed by NIAP Validators through the ECR Process at the completion of testing.",
  },
  {
    id: 13,
    term: "CICO",
    definition: "Check-In/Check-Out",
  },
  {
    id: 14,
    term: "Collaborative Protection Profile (cPP)",
    definition:
      "An internationally recognized Protection Profile developed by an international Technical Community (iTC)",
  },
  {
    id: 15,
    term: "Commercial Solutions for Classified (CSfC)",
    definition:
      "An NSA program for guiding cryptographic solutions development using NIAP evaluated products",
  },
  {
    id: 16,
    term: "Common Criteria (CC)",
    definition:
      "Common Criteria for Information Technology Security Evaluation, the title of a set of documents describing a particular set of IT security evaluation criteria.",
  },
  {
    id: 17,
    term: "Common Criteria Evaluation and Validation Scheme (CCEVS)",
    definition:
      "The program developed by NIST and NSA as part of the National Information Assurance Partnership (NIAP) establishing an organizational and technical framework to evaluate the trustworthiness of IT Products and protection profiles.",
  },
  {
    id: 18,
    term: "Common Criteria Testing Laboratory (CCTL)",
    definition:
      "Within the context of the Common Criteria Evaluation and Validation Scheme (CCEVS), an IT security evaluation facility, accredited by the National Voluntary Laboratory Accreditation Program (NVLAP) and approved by the NIAP Validation Body to conduct Common Criteria-based evaluations.",
  },
  {
    id: 19,
    term: "Common Evaluation Methodology (CEM)",
    definition:
      "Common Methodology for Information Technology Security Evaluations - a technical document that describes a set of IT security evaluation methods.",
  },
  {
    id: 20,
    term: "cPP",
    definition: "Collaborative Protection Profile",
  },
  {
    id: 21,
    term: "CSfC",
    definition: "Commercial Solutions for Classified",
  },
  {
    id: 22,
    term: "DISA",
    definition: "Defense Information Systems Agency",
  },
  {
    id: 23,
    term: "DoD Annex",
    definition:
      "A Protection Profile Annex identifying DoD-mandated selections and requirements that meet DISA STIGs",
  },
  {
    id: 24,
    term: "EAL",
    definition: "Evaluation Assurance Level",
  },
  {
    id: 25,
    term: "EAR",
    definition: "Entropy Assessment Report",
  },
  {
    id: 26,
    term: "ECR",
    definition: "Evaluation Consistency Review",
  },
  {
    id: 27,
    term: "ECR Comment Facility",
    definition:
      "The facility on the NIAP Community Site for the entering and tracking of evaluation issues found through the ECR process.",
  },
  {
    id: 28,
    term: "ECR Process",
    definition: "See Evaluation Consistency Review",
  },
  {
    id: 29,
    term: "Entropy Assessment Report (EAR)",
    definition:
      "A description of how the product being evaluated derives its entropy which sources its cryptographic operations.",
  },
  {
    id: 30,
    term: "Entropy Validation Board",
    definition:
      "The set of Entropy experts that review and provide feedback on evaluation Entropy Assessment Reports.",
  },
  {
    id: 31,
    term: "ETR",
    definition: "Evaluation Technical Report",
  },
  {
    id: 32,
    term: "Evaluation",
    definition:
      "The assessment of an IT product against the Common Criteria using the Common Evaluation Methodology to determine whether or not the claims made are justified; or the assessment of a protection profile against the Common Criteria using the Common Evaluation Methodology to determine if the profile is complete, consistent, technically sound and hence suitable for use as a statement of requirements for one or more TOEs that may be evaluated.",
  },
  {
    id: 33,
    term: "Evaluation Consistency Review (ECR)",
    definition:
      "The process conducted by NIAP Validators for reviewing the evaluation evidence provided by the Lab.",
  },
  {
    id: 34,
    term: "Evaluation Record",
    definition:
      "The complete set of information about an evaluation project, managed on the NIAP Community Site.",
  },
  {
    id: 35,
    term: "Evaluation Technical Report (ETR)",
    definition:
      "A report giving the details of the findings of an evaluation, submitted by the CCTL to the CCEVS Validation Body as the principal basis for the validation report.",
  },
  {
    id: 36,
    term: "Evaluation Work Plan",
    definition:
      "A document produced by a CCTL detailing the organization, schedule, and planned activities for an IT security evaluation.",
  },
  {
    id: 37,
    term: "IAR",
    definition: "Impact Analysis Report",
  },
  {
    id: 38,
    term: "Impact Analysis Report (IAR)",
    definition:
      "Report delivered by a Vendor or Lab detailing a product change as part of the Assurance Maintenance process.",
  },
  {
    id: 39,
    term: "International Technical Community (iTC)",
    definition:
      "A Technical Community managed by the international Common Criteria organization",
  },
  {
    id: 40,
    term: "ISO",
    definition: "International Organization for Standards",
  },
  {
    id: 41,
    term: "IT",
    definition: "Information Technology",
  },
  {
    id: 42,
    term: "iTC",
    definition: "International Technical Community",
  },
  {
    id: 43,
    term: "National Voluntary Laboratory Accreditation Program (NVLAP)",
    definition:
      "NVLAP is the U.S. accreditation authority for CCTLs operating within the NIAP CCEVS.",
  },
  {
    id: 44,
    term: "Network Interpretations Team (NIT)",
    definition:
      "International body supporting interpretations decisions for evaluations against cPPs.",
  },
  {
    id: 45,
    term: "NIAP",
    definition: "National Information Assurance Partnership",
  },
  {
    id: 46,
    term: "NIAP Community Site",
    definition:
      "The private portion of the NIAP website, which requires an account to access it.",
  },
  {
    id: 47,
    term: "NIAP Validation Body",
    definition:
      "A governmental organization responsible for carrying out validation and for overseeing the day-to-day operation of the CCEVS.",
  },
  {
    id: 48,
    term: "NIST",
    definition: "National Institute of Standards and Technology",
  },
  {
    id: 49,
    term: "NIST Evaluation",
    definition:
      "NIST Evaluation refers to NIST's Cryptographic Module Validation Program (CMVP) and/or NIST's Cryptographic Algorithm Validation Program (CAVP), depending on what is required for NIAP evaluation.",
  },
  {
    id: 50,
    term: "NIT",
    definition: "Network Interpretations Team",
  },
  {
    id: 51,
    term: "NSA",
    definition: "National Security Agency",
  },
  {
    id: 52,
    term: "NSS",
    definition: "National Security Systems",
  },
  {
    id: 53,
    term: "NVLAP",
    definition: "National Voluntary Laboratory Accreditation Program",
  },
  {
    id: 54,
    term: "PCL",
    definition: "Product Compliant List",
  },
  {
    id: 55,
    term: "PINE",
    definition:
      "Products In Evaluation list, as found on the NIAP Community Site PINE page.",
  },
  {
    id: 56,
    term: "PP",
    definition: "Protection Profile",
  },
  {
    id: 57,
    term: "Product Compliant List (PCL)",
    definition:
      "The list of products holding a valid CC Certificate approved by NIAP, published on NIAP's website.",
  },
  {
    id: 58,
    term: "Progress Point",
    definition:
      "A pre-defined milestone used on the NIAP Community Site for tracking evaluation project progression through the process.",
  },
  {
    id: 59,
    term: "Protection Profile (PP)",
    definition:
      "An implementation independent set of security requirements for a category of IT products which meet specific consumer needs.",
  },
  {
    id: 60,
    term: "Security Target (ST)",
    definition:
      "A specification of the security required (both functionality and assurance) in a Target of Evaluation (TOE), used as a baseline for evaluation under the CC. The security target specifies the security objectives, the threats to those objectives, and any specific security mechanisms that will be employed.",
  },
  {
    id: 61,
    term: "Security Technical Implementation Guides (STIGs)",
    definition: "DISA-published guides for solution implementations for DoD",
  },
  {
    id: 62,
    term: "SF",
    definition: "Security Function",
  },
  {
    id: 63,
    term: "SFR",
    definition: "Security Functional Requirement",
  },
  {
    id: 64,
    term: "Sponsor",
    definition:
      "The person or organization that requests a security evaluation of an IT product or protection profile.",
  },
  {
    id: 65,
    term: "ST",
    definition: "Security Target",
  },
  {
    id: 66,
    term: "STIGs",
    definition: "Security Technical Implementation Guides",
  },
  {
    id: 67,
    term: "Sync Session",
    definition:
      "A technical meeting between Validators and Evaluators on a project to review progress and discuss PP interpretation.",
  },
  {
    id: 68,
    term: "TC",
    definition: "Technical Community",
  },
  {
    id: 69,
    term: "Technical Community (TC)",
    definition:
      "A collaborative group of Government, industry, and academia with the key goal to develop Protection Profiles.",
  },
  {
    id: 70,
    term: "Technical Rapid Response Team (TRRT)",
    definition:
      "Teams to which anyone (CCTLs, Vendors, Schemes, or NIAP) can direct their technical questions.",
  },
  {
    id: 71,
    term: "TOE",
    definition:
      "Target of Evaluation - An IT product or group of IT products configured as an IT System and associated documentation that is the subject of a security evaluation under the CC. Also, a protection profile that is the subject of a security evaluation under the CC.",
  },
  {
    id: 72,
    term: "TRRT",
    definition: "Technical Rapid Response Team",
  },
  {
    id: 73,
    term: "TSF",
    definition: "TOE Security Function",
  },
  {
    id: 74,
    term: "TSS",
    definition: "TOE Security Specification",
  },
  {
    id: 75,
    term: "Validation",
    definition:
      "The process carried out by the NIAP Validation Body leading to the issue of a CC certificate.",
  },
  {
    id: 76,
    term: "Validation Report (VR)",
    definition:
      "A publicly available document issued by the NIAP Validation Body which summarizes the results of an evaluation and confirms the overall results, (i.e., that the evaluation has been properly carried out, that the CC, the Common Evaluation Methodology, and scheme-specific procedures have been correctly applied; and that the conclusions of the Evaluation Technical Report are consistent with the evidence adduced).",
  },
  {
    id: 77,
    term: "VID",
    definition:
      "Validation Identifier - the number assigned to an Evaluation Project for tracking",
  },
  {
    id: 78,
    term: "VR",
    definition: "Validation Report",
  },
];
